import { ReactNode, useLayoutEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import tw, { TwStyle } from 'twin.macro';

import useOnClickOutside from '@app/hooks/useOnClickOutside';

const Overlay = tw.div`fixed top-0 right-0 bottom-0 left-0 flex flex-col items-start justify-center bg-muted-transparent z-[999] p-10 overflow-y-scroll`;
export const ModalHeader = tw.div`w-full bg-neutral-background px-6 py-2 border-b border-solid border-gray-1 flex items-center justify-between rounded-t-lg`;
export const ModalContent = tw.div`rounded-lg h-auto w-full max-w-[calc(100% - 76px)] max-h-screen mx-auto flex justify-center items-center flex-col`;

export const Modal = ({
  children,
  onClose,
  overlayStyles,
  closeOnClickOutside = false,
}: {
  children: ReactNode;
  onClose: () => void;
  overlayStyles?: TwStyle | null;
  closeOnClickOutside?: boolean;
}) => {
  const onKeyDownHandler = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  const modalContentRef = useRef<HTMLDivElement>(null);
  closeOnClickOutside && useOnClickOutside(modalContentRef, () => onClose());

  const content: ReactNode = (
    <Overlay css={[overlayStyles && overlayStyles]}>
      <ModalContent ref={modalContentRef}>{children}</ModalContent>
    </Overlay>
  );

  useLayoutEffect(() => {
    window.addEventListener('keydown', onKeyDownHandler);

    return () => window.removeEventListener('keydown', onKeyDownHandler);
  }, []);

  return createPortal(content, document.getElementById('modal-root') as HTMLElement);
};
